import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "launcher" }
const _hoisted_2 = { class: "d-flex flex-column flex-column-fluid mb-5 mb-lg-10" }
const _hoisted_3 = { class: "row g-7 w-xxl-850px" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-xxl-center justify-content-between pt-10 pt-xxl-0 mb-10 mb-xxl-0 h-xxl-225px" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"btn btn-icon btn-active-color-primary w-30px h-30px d-xxl-none me-4 ms-n15\" id=\"kt_sidebar_toggle\"><span class=\"svg-icon svg-icon-1\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z\" fill=\"black\"></path><path opacity=\"0.3\" d=\"M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z\" fill=\"black\"></path></svg></span></div>", 1)
const _hoisted_6 = { class: "col-xxl-5" }
const _hoisted_7 = { class: "col-xxl-7" }
const _hoisted_8 = { class: "row g-lg-7" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"card border-0 shadow-none min-h-200px\" style=\"background-color:#d5d83d;\"><div class=\"card-body d-flex flex-center flex-wrap\"><img class=\"mw-100 h-200px me-4 mb-5 mb-lg-0\" src=\"/media/illustrations/sigma-1/11.png\"><div class=\"d-flex flex-column align-items-center align-items-md-start flex-grow-1\"><h3 class=\"text-gray-900 fw-boldest text-uppercase mb-5\"> Quick Guide </h3><div class=\"text-gray-800 mb-5 text-center text-md-start\"> Explore our powerful <br>documentation </div><a href=\"/metronic8/demo10/../demo10/documentation/getting-started.html\" class=\"btn btn-hover-rise text-gray-900 text-uppercase fs-7 fw-bolder\" style=\"background-color:#ebee51;\">Learn More</a></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_UserMenu = _resolveComponent("UserMenu")!
  const _component_CardCreateModal = _resolveComponent("CardCreateModal")!
  const _component_SidebarDefault = _resolveComponent("SidebarDefault")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Logo),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_UserMenu)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_CardCreateModal, {
                buttonText: _ctx.$t('create_account'),
                image: "/media/illustrations/sigma-1/4.png",
                modalId: "kt_modal_create_account",
                color: "#f9666e"
              }, null, 8, ["buttonText"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_CardCreateModal, {
                buttonText: _ctx.$t('create_invoice'),
                image: "/media/illustrations/sigma-1/5.png",
                modalId: "kt_modal_create_invoice",
                color: "#35d29a"
              }, null, 8, ["buttonText"])
            ])
          ]),
          _hoisted_11
        ])
      ])
    ]),
    _createVNode(_component_SidebarDefault)
  ]))
}